import { SyntheticEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import {
  Autocomplete,
  CircularProgress,
  FormControl,
  FormHelperText,
  FormLabel,
  TextField,
} from '@mui/material';
import { $openedId } from '../../../models/detail-sdui-opened-id';
import {
  $getRelatedAvailablePending,
  $relatedAvailable,
  $relatedAvailableOptions,
  addRelatedAvailable,
  getRelatedAvailable,
} from '../../../models/related-tickets';
import { AllreadyRelatedTickets } from '../allready-related-tickets';
import * as Styled from '../styled';
import { Actions } from './actions';
import { RenderOption } from './option';

export const RetaledAvailableSelect = () => {
  const { t } = useTranslation();
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [isError, setIsError] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [
    openedId,
    relatedAvailableOptions,
    relatedAvailable,
    getRelatedAvailablePending,
  ] = useUnit([
    $openedId,
    $relatedAvailableOptions,
    $relatedAvailable,
    $getRelatedAvailablePending,
  ]);

  const onChange = (_: SyntheticEvent, newValue: any[]) => addRelatedAvailable(newValue);

  const onInputChange = (_: SyntheticEvent, newInputValue: string) =>
    setInputValue(newInputValue);

  useEffect(() => {
    getRelatedAvailable({ id: String(openedId!), query: inputValue });
  }, [inputValue]);

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);

      return;
    }

    setIsError(!relatedAvailable.length);
  }, [relatedAvailable.length]);

  return (
    <FormControl required>
      <FormLabel error={isError}>{t('RequestNumber')}</FormLabel>

      <Autocomplete
        value={relatedAvailable}
        onChange={onChange}
        inputValue={inputValue}
        onInputChange={onInputChange}
        loading={getRelatedAvailablePending}
        options={relatedAvailableOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options) => options}
        renderOption={RenderOption}
        multiple
        getOptionLabel={(option) => option.title.value ?? ''}
        disableCloseOnSelect
        renderInput={(params) => (
          <TextField
            {...params}
            slotProps={{
              input: {
                ...params.InputProps,
                error: isError,
                endAdornment: (
                  <>
                    {getRelatedAvailablePending ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
      />

      {isError && <FormHelperText error>{t('thisIsRequiredField')}</FormHelperText>}
    </FormControl>
  );
};

export const RetaledAvailable = () => (
  <>
    <AllreadyRelatedTickets />

    <Actions />

    <Styled.Body>
      <RetaledAvailableSelect />
    </Styled.Body>
  </>
);
